require('daterangepicker');

export default{
    init(){
        let startDate=null;
        let endDate=null;

        this.setDateTimePicker();
        this.searchEmployer();
        this.logsModals();
    },

    setDateTimePicker(){
        let statisticsDateInout = $('#statistics_date');
        statisticsDateInout.daterangepicker({
            format: 'MM/DD/YYYY',
            separator: ' - ',
        });
        statisticsDateInout.on('apply.daterangepicker', (ev, picker) => {
            this.startDate = picker.startDate.format('YYYY-MM-DD');
            this.endDate = picker.endDate.format('YYYY-MM-DD');
            console.log(this.startDate, this.endDate);
            this.updateTable(this.startDate, this.endDate, $('input#employer_text').val());
        });
    },

    updateTable(startDate, endDate, employer=null){
        $.ajax({
            type: "GET",
            url: '/cockpit/statistics',
            data: ({
                start_date: startDate,
                end_date: endDate,
                employer_text: employer,
            }),
            success: function (response) {
                console.log(response);
                $('.statistics-container').html(response);
            }
        });
    },

    searchEmployer(){
        $('select#employer_text').change(() => {
            /* let statisticsDateInout = $('#statistics_date');

            this.startDate = $('#statistics_date').data('daterangepicker').startDate.format('YYYY-MM-DD');
            this.endDate = $('#statistics_date').data('daterangepicker').endDate.format('YYYY-MM-DD');
            this.updateTable(this.startDate, this.endDate, $('input#employer_text').val()); */
            let this_value = $('select#employer_text').val();
            let table_rows = $('.cockpit_statistics_table').find('tr.employee-row').toArray();
            table_rows.forEach(element => {
                if (this_value == 'none') {
                    $(element).removeClass('d-none');
                } else {
                    if (this_value == $(element).data('employee_id')) {
                        $(element).removeClass('d-none');
                    } else {
                        $(element).addClass('d-none');
                    }
                }
            });
        })
    },

    logsModals(){
        $('body').on('click', '.show_logs_online_modal', function (e) {
            $.ajax({
                type: 'GET',
                url: '/cockpit/cockpit-logs-online',
                data: ({
                    id: $(this).data('user_id'),
                    date: $(this).data('date_now'),
                }),
                success: function (response) {
                    $('#cockpit_logs_online_data').html(response);
                    $('#logs_online_modal').modal('show');
                },
            });
        });
    }
}
